import { Injectable } from '@angular/core';
import { LocationService } from '@callrail/looky/util';

import { CurrentContextService } from './../current-context/current-context.service';

@Injectable({
  providedIn: 'root',
})
export class BaseHostService {
  constructor(
    private context: CurrentContextService,
    private locationService: LocationService
  ) {}

  public get baseHost(): string {
    if (this.locationService.host().includes('localhost')) {
      return this.locationService.host();
    }
    return this.context.env.base_host;
  }

  public get baseHostUrl(): string {
    const absPath = this.locationService.absPath();
    const protocol = this.locationService.protocol.replace(':', '');
    return `${protocol}://${this.baseHost}${absPath}`;
  }

  public get isAuthorizableDomain(): boolean {
    return (
      this.locationService.host() === this.baseHost ||
      this.isDev ||
      this.baseHost.match(/.*(\.pipe\.callrail\.com)$/) !== null
    );
  }

  private get isDev(): boolean {
    return ['staging', 'development'].includes(this.context.env.environment);
  }
}
